export default __webpack_public_path__ + "ocr/worker.min-514c4b0a1fa9a086ca9ab8bfb7df6c9d.js";